import styled, { keyframes, css } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(20px);
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div<{ $visible: boolean }>`
  position: fixed;
  top: 32px;
  right: 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  pointer-events: auto;
  z-index: 1000;
  min-width: 240px;

  animation: ${({ $visible }) => ($visible ? fadeIn : fadeOut)} 300ms
    ease-in-out forwards;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  transition:
    opacity 300ms ease-in-out,
    transform 300ms ease-in-out;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
`;

export const IconWrapper = styled.div<{ $status?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
    fill: ${({ $status }) => {
      switch ($status) {
        case 'success':
          return '#4caf50';
        case 'failed':
          return '#f44336';
        default:
          return '#4fc3f7';
      }
    }};
    ${({ $status }) =>
      $status === 'installing' &&
      css`
        animation: ${spin} 1s linear infinite;
      `}
  }
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
  margin-top: 4px;
`;

export const ProgressBarFill = styled.div<{ $progress: number }>`
  height: 100%;
  width: ${({ $progress }) => $progress}%;
  background: linear-gradient(90deg, #4fc3f7, #0288d1);
  border-radius: 3px;
  transition: width 300ms ease-out;
`;

export const ProgressText = styled.div`
  font-size: 14px;
  color: #b0bec5;
  text-align: center;
  margin-top: 2px;
`;

export const ErrorMessage = styled.div`
  font-size: 13px;
  color: #ef5350;
  margin-top: 4px;
  line-height: 1.4;
`;

export const DismissButton = styled.button`
  margin-top: 8px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: #ffffff;
  font-size: 13px;
  cursor: pointer;
  transition: all 200ms ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
  }

  &:focus {
    outline: 2px solid #4fc3f7;
    outline-offset: 2px;
  }
`;
